import { SvgIcon, SvgIconProps } from '@mui/material'
import { FC } from 'react'

export const UploadOutlinedIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 9C6.25 5.54822 9.04822 2.75 12.5 2.75C15.4382 2.75 17.9045 4.7782 18.5719 7.51188C18.6301 7.75035 18.8014 7.94523 19.0304 8.03365C20.6226 8.64848 21.75 10.1935 21.75 12C21.75 13.39 21.0835 14.624 20.0496 15.4007C19.7184 15.6495 19.6516 16.1196 19.9003 16.4508C20.1491 16.782 20.6192 16.8488 20.9504 16.6C22.3454 15.5523 23.25 13.8817 23.25 12C23.25 9.69141 21.8898 7.70217 19.9293 6.78706C18.9768 3.58539 16.012 1.25 12.5 1.25C8.3612 1.25 4.98014 4.49432 4.76126 8.57854C2.99832 9.27243 1.75 10.9897 1.75 13C1.75 14.7591 2.70663 16.2939 4.12446 17.1141C4.483 17.3215 4.9418 17.199 5.1492 16.8404C5.35661 16.4819 5.23409 16.0231 4.87554 15.8157C3.90216 15.2526 3.25 14.202 3.25 13C3.25 11.4863 4.28548 10.2126 5.68784 9.85211C6.02413 9.76566 6.2571 9.45969 6.25099 9.11252C6.25033 9.0751 6.25 9.0376 6.25 9ZM16.5303 14.9697L13.0303 11.4697C12.7374 11.1768 12.2626 11.1768 11.9697 11.4697L8.46967 14.9697C8.17678 15.2626 8.17678 15.7374 8.46967 16.0303C8.76256 16.3232 9.23744 16.3232 9.53033 16.0303L11.75 13.8107V21C11.75 21.4142 12.0858 21.75 12.5 21.75C12.9142 21.75 13.25 21.4142 13.25 21V13.8107L15.4697 16.0303C15.7626 16.3232 16.2374 16.3232 16.5303 16.0303C16.8232 15.7374 16.8232 15.2626 16.5303 14.9697Z"
        fill="#22282F"
      />
    </SvgIcon>
  )
}
